import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'

type Props = {

}

const AumLine = () => {
    const { typography, palette } = useTheme()
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '14px', alignItems: 'center' }}>
            <Typography variant='body_400' sx={{ textWrap: 'nowrap' }} color={palette.text.primary}>May 2024</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', height: '10px' }}>
                <Box sx={{
                    width: '10%',
                    background: palette.customColors.aumRed,
                    borderRadius: '0 5px 5px 0',
                    marginRight: '-5px',
                    zIndex: 3
                }} />
                <Box sx={{
                    width: '20%',
                    background: palette.customColors.aumOrange,
                    borderRadius: '0 5px 5px 0',
                    marginRight: '-5px',
                    zIndex: 2
                }} />
                <Box sx={{
                    width: '30%',
                    background: palette.customColors.aumBlue,
                    borderRadius: '0 5px 5px 0',
                    marginRight: '-5px',
                    zIndex: 1
                }} />
            </Box>
        </Box>
    )
}

export default AumLine